import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Button, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';
import config from '../config';
import { usePermissions } from '../Components/Hooks/PermissionHooks';

// Import git info (auto-generated)
let gitInfo = { branch: 'unknown', timestamp: '' };
try {
  gitInfo = require('../git-info.json');
} catch (error) {
  // Fallback if file doesn't exist
  console.log('Git info not available:', error.message);
}

const Footer = () => {
    const [maintenanceMode, setMaintenanceMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const { isAdmin } = usePermissions();

    // Check maintenance status on mount
    useEffect(() => {
        checkMaintenanceStatus();
    }, []);

    const checkMaintenanceStatus = async () => {
        try {
            const token = sessionStorage.getItem('authUser') ? JSON.parse(sessionStorage.getItem('authUser')!).token : null;
            const response = await fetch(`${config.api.API_URL}/maintenance/status`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.ok) {
                const data = await response.json();
                setMaintenanceMode(data.data.enabled);
            }
        } catch (error) {
            console.error('Error checking maintenance status:', error);
        }
    };

    const toggleMaintenance = async () => {
        setLoading(true);
        try {
            const token = sessionStorage.getItem('authUser') ? JSON.parse(sessionStorage.getItem('authUser')!).token : null;
            const response = await fetch(`${config.api.API_URL}/maintenance/toggle`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    enabled: !maintenanceMode,
                    message: 'Wartungsarbeiten - Die Anwendung ist in wenigen Minuten wieder verfügbar.',
                    allowedIPs: ['127.0.0.1', '::1', '::ffff:127.0.0.1']
                })
            });
            
            if (response.ok) {
                const data = await response.json();
                setMaintenanceMode(data.data.enabled);
            }
        } catch (error) {
            console.error('Error toggling maintenance:', error);
        } finally {
            setLoading(false);
        }
    };

    // isAdmin is now provided by usePermissions hook

    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            <div className="d-flex align-items-center">
                                <span>{new Date().getFullYear()} © MXR Productions</span>
                                {isAdmin() && (
                                    <Button
                                        color={maintenanceMode ? "danger" : "warning"}
                                        size="sm"
                                        className="ms-3"
                                        onClick={toggleMaintenance}
                                        disabled={loading}
                                        title={maintenanceMode ? "Wartungsmodus deaktivieren" : "Wartungsmodus aktivieren"}
                                    >
                                        {loading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <>
                                                <i className={`ri-${maintenanceMode ? 'tools-fill' : 'tools-line'} me-1`}></i>
                                                {maintenanceMode ? 'Wartung AUS' : 'Wartung AN'}
                                            </>
                                        )}
                                    </Button>
                                )}
                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                <Link 
                                    to="/version-history" 
                                    className="me-3 text-muted text-decoration-none"
                                    style={{ transition: 'opacity 0.2s' }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                    title="View version history"
                                >
                                    v{config.app.version}
                                </Link>
                                {config.app.environment !== 'production' && gitInfo.branch !== 'unknown' && (
                                    <span className="me-3 text-muted">
                                        <i className="ri-git-branch-line me-1"></i>
                                        {gitInfo.branch}
                                    </span>
                                )}
                                Developed with ❤️ by Christoph Tilley and his ai buddies 🤖
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;